import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getDraftDocument(projectName, formName, documentId) {
    try {
        const url = `/project/${projectName}/${formName}/Document/${documentId}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        store.dispatch(showToastAction({
            message: error.response?.data?.errorMessage ?? "Error fetching draft document",
            showToast: true
        }));
        return null;
    }
}
